import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
import { FrontendModalService } from '@tablesready/frontend-modal';
import {
  filter,
  Subscription,
} from 'rxjs';
import { WindowHeightService } from '@tablesready/frontend-nav-sidebar';

const VERTICAL_PADDING = 32;

@Directive({ selector: '[modalContent]' })
export class FrontendModalContentDirective implements AfterViewInit, OnDestroy {
  private headerHeight?: number;
  private footerHeight?: number;
  private windowHeight?: number;
  private readonly subscription = new Subscription();

  constructor(
    private readonly el: ElementRef,
    private readonly service: FrontendModalService,
    private readonly heightService: WindowHeightService,
  ) {
    this.el.nativeElement.style.maxHeight = '0';
  }

  ngAfterViewInit(): void {
    this.heightService.height$.subscribe((windowHeight) => {
      this.windowHeight = windowHeight;
    });

    const footerSub = this.service.footerHeightSet$
      .pipe(
        filter(data => data !== null),
      )
      .subscribe((footer) => {
        this.footerHeight = footer;
        this.setContentHeight();
      });
    this.subscription.add(footerSub);

    const headerSub = this.service.headerHeightSet$
      .pipe(
        filter(data => data !== null),
      )
      .subscribe((header) => {
        this.headerHeight = header;
        this.setContentHeight();
      });
    this.subscription.add(headerSub);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private setContentHeight(): void {
    if (!this.headerHeight || !this.footerHeight) {
      return;
    }

    let height = '100vh';

    if (this.windowHeight) {
      height = `${this.windowHeight}px`;
    }

    this.el.nativeElement.style.overflowY = 'auto';
    this.el.nativeElement.style.maxHeight = `calc(${height} - var(--ion-safe-area-top, 0) - var(--ion-safe-area-bottom, 0) - ${this.headerHeight + this.footerHeight + VERTICAL_PADDING}px)`;
  }
}
